export enum FeedbackStatus {
  INIT = 'Init',
  SENDING = 'Sending',
  SENT = 'Sent',
  ERROR = 'Error',
}
